import { isCnArea, isFWebSite } from '@/utils/envHelper';

const linksConfig = {
  FWebsite: {
    privacy:
      // 'https://rc.avaclon.com/web/h5template/c19adcee-2f2e-4507-98bf-7e36866d807e-language=en/dist/index.html',
      '/privacy',
    terms:
      // 'https://rc.avaclon.com/web/h5template/0041cf6c-1a08-445d-b4f1-9f50387ee15d-language=en/dist/index.html',
      '/terms',
    membership:
      // 'https://rc.avaclon.com/web/h5template/393781f4-0738-4687-9fda-ffc1512d0c1c-language=en/dist/index.html',
      '/member',
  },
  BUS: {
    privacy:
      'https://rc.avaclon.com/web/h5template/366fd774-0280-4f8c-b772-881397d5068c-language=en/dist/index.html',
    terms:
      'https://rc.avaclon.com/web/h5template/c783a136-a4c1-4a71-95c5-f880d56a25dc-language=en/dist/index.html',
    membership:
      'https://rc.avaclon.com/web/h5template/869426be-7f01-4f59-9011-99d3228f659b-language=en/dist/index.html',
  },
  BCN: {
    privacy:
      'https://rc.avaclon.com/web/h5template/366fd774-0280-4f8c-b772-881397d5068c-language=zh/dist/index.html',
    terms:
      'https://rc.avaclon.com/web/h5template/c783a136-a4c1-4a71-95c5-f880d56a25dc-language=zh/dist/index.html',
    membership:
      'https://rc.avaclon.com/web/h5template/869426be-7f01-4f59-9011-99d3228f659b-language=zh/dist/index.html',
  },
};

const getLinks = () => {
  if (isFWebSite) {
    return linksConfig.FWebsite;
  } else if (isCnArea) {
    return linksConfig.BCN;
  } else {
    return linksConfig.BUS;
  }
};

const { privacy, terms, membership } = getLinks();

export const PrivacyLink = privacy;
export const TermsLink = terms;
export const MembershipLink = membership;
